import { Component, Inject, OnInit, ViewChild } from '@angular/core';

import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MapServiceService } from 'src/app/modules/map/services/Map-service/map-service.service';
import { SideNavService } from 'src/app/modules/map/services/sidenav/side-nav.service';

import { LoaderComponent } from 'src/app/modules/shared/components/loader/loader.component';

@Component({
  selector: 'app-pdf-table',
  templateUrl: './pdf-table.component.html',
  styleUrls: [
    '../view-and-export-data.component.css',
    './pdf-table.component.css',
  ],
})
export class PdfTableComponent implements OnInit {
  layerFeatures: any;
  skipDuplicates: any = false;
  title: any = '';
  url: any;
  arr: any = [];
  selectlayerData = false;
  checkLayersId: any = [];
  showMsg = false;
  divShow = false;
  showParcel = true;
  layerName: any;
  step1 = '';
  step2 = '';
  step3 = '';
  boundaries: any;
  parcelId: any;
  verify1: any;
  verify2: any;
  downloadFile: any;
  mapId:any
  @ViewChild(LoaderComponent) loader!: LoaderComponent;
  constructor(
    private sideNavService: SideNavService,
    private mapService: MapServiceService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    //
  }

  ngOnInit(): void {
    this.mapId = this.mapService.mapData.map_data.map_data.id;
    this.boundaries = this.mapService.mapData.map_data.map_data.layers;
    //getting id for parcel
    if (this.data.features.length > 0) {
      for (let i = 0; i <= this.boundaries.length; i++) {
        for (let j = 0; j < this.data.features.length; j++) {
          if (!this.checkLayersId.includes(this.data.features[j].layer_id)) {
            this.checkLayersId.push(this.data.features[j].layer_id);
          }

          if (
            this.boundaries[i]?.id.toString() ==
              this.data.features[j].layer_id &&
            (this.boundaries[i].name === 'Parcels' ||
              this.boundaries[i].name.toLowerCase().includes('parcels'))
          ) {
            this.layerName = this.boundaries[i].name;
            this.parcelId = this.data.features[j].layer_id;
            break;
          }
        }
      }
    } else {
      for (let i = 0; i <= this.boundaries.length; i++) {
        if (
          this.boundaries[i]?.id.toString() == this.data.features.layer_id &&
          (this.boundaries[i].name === 'Parcels' ||
            this.boundaries[i].name.toLowerCase().includes('parcels'))
        ) {
          this.parcelId = this.data.features.layer_id;
          this.layerName = this.boundaries[i].name;
          break;
        }
      }
    }
    //to check if different layers is present include parcel

    for (let j = 0; j < this.data.features.length; j++) {
      if (this.parcelId) {
        if (this.data.features[j].layer_id == this.parcelId.toString()) {
          this.verify1 = true;
          break;
        }
      } else {
        this.verify1 = false;
        break;
      }
    }
    if (this.verify1) {
      for (let j = 0; j < this.data.features.length; j++) {
        if (this.data.features[j].layer_id != this.parcelId.toString()) {
          this.verify2 = true;

          break;
        }
      }
    }
    if (!this.data.features.length) {
      this.step1 = '';
      this.step2 = '';
      this.step3 = '';
      this.step1 = '1';
      this.step2 = '2';
      this.step3 = '3';
      this.showParcel = false;
      if (this.parcelId.toString() == this.data.features.layer_id) {
        this.arr.push(this.data.features.id);
      }
    } else if (!this.verify1) {
      for (let i = 0; i < this.data.features.length; i++) {
        this.showParcel = false;
        this.step1 = '';
        this.step2 = '';
        this.step3 = '';
        this.step1 = '1';
        this.step2 = '2';
        this.step3 = '3';
        if (this.parcelId) {
          if (this.parcelId.toString() == this.data.features[i].layer_id) {
            this.arr.push(this.data.features[i].id);
          }
        }
      }
    } else {
      if (this.verify2) {
        for (let i = 0; i < this.data.features.length; i++) {
          this.showParcel = true;
          this.step1 = '';
          this.step2 = '';
          this.step3 = '';
          this.step1 = '1';
          this.step2 = '2';
          this.step3 = '3';
          if (this.parcelId.toString() == this.data.features[i].layer_id) {
            this.arr.push(this.data.features[i].id);
          }
        }
      } else {
        for (let i = 0; i < this.data.features.length; i++) {
          this.showParcel = false;
          this.step1 = '';
          this.step2 = '';
          this.step3 = '';
          this.step1 = '1';
          this.step2 = '2';
          this.step3 = '3';
          if (this.parcelId.toString() == this.data.features[i].layer_id) {
            this.arr.push(this.data.features[i].id);
          }
        }
      }
    }
  }
  layerDataType(value: boolean): void {
    this.selectlayerData = value;
  }
  download(): void {
    if (this.showParcel) {
      if (this.selectlayerData && this.arr.length != 0) {
        this.showMsg = false;
        this.loader.toggleSpinner(true);
        this.mapService
          .getPdfDataField(
            this.parcelId.toString(),
     this.mapId,
            this.arr.toString()
          )
          .subscribe((res) => {
            if (res) {
              const body = {
                download_type: 'pdf_table',
                show_apn: true,
                use_mail_address: false,
                use_situs_address: false,
                skip_duplicates: this.skipDuplicates,
                table_name: this.title || ' ',
                layer_name: this.layerName,
                map_name: this.mapService.mapData.map_data.map_data.name,
                features: res.results[0],
              };
              if (this.selectlayerData == true) {
                this.mapService.dataView(body).subscribe((res: any) => {
                  this.url = `${this.sideNavService.downloadFileUrl}/${res.file_path}`;
                  const element1: any = document.getElementById('submit-pdf1');
                  element1.href = this.url;
                  element1.target = '_blank';
                  this.loader.toggleSpinner(false);
                  element1.click();
                  element1.href = '';
                });
              } else {
                this.showMsg = true;
              }
            }
          });
      }
    } else {
      if (this.arr.length != 0) {
        this.showMsg = false;
        this.loader.toggleSpinner(true);
        this.mapService
          .getPdfDataField(
            this.parcelId.toString(),
           this.mapId,
            this.arr.toString()
          )
          .subscribe((res: any) => {
            if (res) {
              const body = {
                download_type: 'pdf_table',
                show_apn: true,
                use_mail_address: false,
                use_situs_address: false,
                skip_duplicates: this.skipDuplicates,
                table_name: this.title || ' ',
                layer_name: this.layerName,
                map_name: this.mapService.mapData.map_data.map_data.name,
                features: res.results[0],
              };
              this.mapService.dataView(body).subscribe((res: any) => {
                this.url = `${this.sideNavService.downloadFileUrl}/${res.file_path}`;
                const element1: any = document.getElementById('submit-pdf1');
                element1.href = this.url;
                element1.target = '_blank';
                this.loader.toggleSpinner(false);
                element1.click();
                element1.href = '';
              });
            }
          });
      }
    }
  }
}
